import { cfetch } from '@confluence/network';

const sanitizeUrl = (url: string) => url.replace(/[^\w\-/.:%?=]+/g, '');

export type GetAIUnsplashPromptParams = {
	title: string;
	locale: string;
};

export async function getAIUnsplashPrompt({
	title,
	locale,
}: GetAIUnsplashPromptParams): Promise<string> {
	return cfetch('/gateway/api/assist/chat/v1/invoke_agent', {
		method: 'POST',
		headers: {
			'content-type': 'application/json;charset=UTF-8',
			'x-experience-id': 'editor',
			'x-product': 'confluence',
		},
		body: JSON.stringify({
			recipient_agent_named_id: 'editor_intent_agent',
			agent_input_context: {
				// eslint-disable-next-line
				content_url: sanitizeUrl(document.location.href),
				writing_intent: 'unsplash_header_image.json',
				draft_full_content: title,
				draft_selected_content: undefined,
				supported_markdown_nodes: [
					'PARAGRAPH',
					'BULLET_LISTS',
					'NUMBERED_LISTS',
					'HEADING',
					'BLOCKQUOTES',
					'CODEBLOCKS',
					'HORIZONTAL_RULE',
					'TABLE',
					'IMAGES',
					'TASK_LIST',
					'LINK',
					'ITALICS',
					'BOLD',
					'STRIKETHROUGH',
					'CODE_SPAN',
				],
				input_mime_type: 'text/markdown',
				output_mime_type: 'text/markdown',
				locale,
				product: 'CONFLUENCE',
			},
		}),
	})
		.then((response) => response.json())
		.then((responseData) => {
			return responseData.message.content;
		});
}
